export default __webpack_public_path__ + "static/media/37.5daf3e76.png";